import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useClientData } from "../../../../../store/client/client.selectors";

import { transformHTPP, transformJS } from "../../../../../utils/helpers";

import {
  useFingerprintHTPPAdapter,
  useFingerprintJSAdapter,
  useGetDataForJSAttributes,
  useSearchFilter,
} from "../../../../../hooks";

import {
  CustomSuBAndDescription,
  Input,
  TabPanel,
} from "../../../../../components";
import AccordionTable from "../../../../../components/common/AccordionTable";
import { addStyles } from "./addStyles";
import { useMockDataHTPP } from "./mockDataHTPP";
import { useMockDataJS } from "./mockDataJS";

import { TabStyled, TabsStyled, WrapperTable } from "./attributeTable.styled";

export const AttributeTable = () => {
  const [value, setValue] = useState(0);
  const { t } = useTranslation();
  let mockDataHTPP = useMockDataHTPP(t);
  let mockDataJS = useMockDataJS(t);

  const { anonymityInfo } = useClientData();
  const { attributesJS } = useGetDataForJSAttributes();

  if (anonymityInfo) {
    mockDataHTPP = transformHTPP(mockDataHTPP, anonymityInfo);
  }
  if (anonymityInfo && attributesJS) {
    mockDataJS = transformJS(mockDataJS, anonymityInfo, attributesJS);
  }

  const { handleSearchChange, filterData } = useSearchFilter();

  const HTPP = useFingerprintHTPPAdapter();
  const JS = useFingerprintJSAdapter();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isFirst = value === 0;

  return (
    <>
      <TabsStyled
        onChange={handleChange}
        value={value}
        aria-label="Tabs where each tab needs to be selected manually"
        TabIndicatorProps={{
          style: { display: "none" },
        }}
      >
        <TabStyled
          tabIndex={0}
          label={t("scannerFingerprint.tabHTTP")}
          hover={!isFirst}
        />
        <TabStyled
          tabIndex={0}
          label={t("scannerFingerprint.tabJS")}
          hover={isFirst}
        />
      </TabsStyled>
      <CustomSuBAndDescription
        sub={
          isFirst
            ? t("scannerFingerprint.tabHTTP")
            : t("scannerFingerprint.tabJS")
        }
      />
      <Input
        fullWidth
        className="grey"
        placeholder={t("global.searchAttribute")}
        addStyles={addStyles.input}
        onChange={handleSearchChange}
      />
      <TabPanel value={value} index={0}>
        <WrapperTable>
          <AccordionTable
            data={filterData(mockDataHTPP)}
            headerData={HTPP.headerData}
            renderRowContent={HTPP.renderRowContent}
            renderDropdownContent={HTPP.renderDropdownContent}
            renderHeaderTitle={HTPP.renderHeaderTitle}
            gridSettings={"310px 142px 1fr"}
            showStatus
          />
        </WrapperTable>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <WrapperTable>
          <AccordionTable
            data={filterData(mockDataJS)}
            headerData={JS.headerData}
            renderRowContent={JS.renderRowContent}
            renderDropdownContent={JS.renderDropdownContent}
            renderHeaderTitle={JS.renderHeaderTitle}
            gridSettings={"310px 142px 1fr"}
            showStatus
          />
        </WrapperTable>
      </TabPanel>
    </>
  );
};
